<template>
  <OAuthCallback
    :service-name="$t('oauthCallback.service.zoom')"
    wait-loader="connectZoomApiWait"
    :success="success"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ZoomSettingApiService } from '@/api/user/resources/zoom_setting';
import { useQueryParameter } from '@/composable/query-parameter';
import OAuthCallback from './OAuthCallback.vue';

export default defineComponent({
  components: {
    OAuthCallback,
  },
  setup() {
    const { param: code } = useQueryParameter<string>('code');

    return { code };
  },
  data() {
    return {
      loading: true,
      success: true,
    };
  },
  created() {
    this.connectZoomApi(this.code);
  },
  methods: {
    async connectZoomApi(code: string): Promise<void> {
      this.$wait.start('connectZoomApiWait');
      const apiService = new ZoomSettingApiService();
      try {
        await apiService.connectZoomApi({
          request: {
            connectZoomApiBody: {
              code,
              origin: location.host,
            },
          },
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.$wait.end('connectZoomApiWait');
      }
    },
  },
});
</script>

